import { useState, useEffect, useCallback } from 'react';
import { Timer, ActivityAction } from '../types';
import { apiService } from '../services/apiService';

export const useTimers = (dogProfile: any) => {
  const [timers, setTimers] = useState<Timer[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const loadTimers = useCallback(async () => {
    if (!dogProfile) return;
    
    try {
      setLoading(true);
      const timerData = await apiService.getTimerStatus();
      setTimers(timerData);
      setError(null);
    } catch (err) {
      setError('Failed to load timers');
      console.error('Error loading timers:', err);
    } finally {
      setLoading(false);
    }
  }, [dogProfile]);

  const completeTimer = async (activityConfigId: string, activity: ActivityAction) => {
    try {
      await apiService.completeTimer(activityConfigId, activity);
      await loadTimers(); // Refresh timers after completion
    } catch (err) {
      setError('Failed to complete timer');
      throw err;
    }
  };

  // Auto-refresh timers every minute when there's a dog profile
  useEffect(() => {
    if (dogProfile) {
      loadTimers();
      const interval = setInterval(loadTimers, 60000);
      return () => clearInterval(interval);
    }
  }, [dogProfile, loadTimers]);

  return {
    timers,
    loading,
    error,
    loadTimers,
    completeTimer
  };
};